import React, {useEffect, useState} from 'react';
import 'react-day-picker/dist/style.css';
import {UseIoC} from "../composers/composer-plugins/use-ioc";

import {DatetimeUtils} from "../../../infrastructure/utils/datetime-utils";
import {TermsUtils} from "../../../infrastructure/utils/terms-utils";
import {countdownHelper} from "../../../infrastructure/utils/countdown-utils";
import {COUNTDOWN} from "./countdown.consts";

export const CountdownComposer = (Countdown) => UseIoC()((props) => {
  const datetimeUtils: DatetimeUtils = props.ioc.getInstance(DatetimeUtils);
  const termsUtils: TermsUtils = props.ioc.getInstance(TermsUtils);

  const [countdownText, setCountdownText] = useState(null);
  const [intervalId, setIntervalId] = useState(null);

  useEffect(() => {
    clearInterval(intervalId);

    if (props.game.showCountdown) {
      setCountdownText(countdownHelper.getCountdown(props.game.startTime));

      initInterval(() => {
        const countdown = countdownHelper.getCountdown(props.game.startTime);

        return setCountdownText(countdown)
      }, COUNTDOWN.SECOND);
    }
  }, [props.game.showCountdown])


  const initInterval = (callback, timeout) => setIntervalId(setInterval(callback, timeout));

  const gameTimeText = () => {
    const daysLeft = datetimeUtils.diffDaysByDate(props.game.startTime);
    const date: String = daysLeft <= 365 ? datetimeUtils.toShortNamedDate(props.game.startTime) : datetimeUtils.toShortDate(props.game.startTime);
    let gameTimeText = date;

    const showDate: Boolean = daysLeft > COUNTDOWN.MAX_DAYS;
    const showDaysCounter: Boolean = daysLeft > 1 && daysLeft <= COUNTDOWN.MAX_DAYS;
    const showTomorrow: Boolean = daysLeft === 1;

    if (showTomorrow) {
      gameTimeText = termsUtils.terms.GAME_TIME_TOMORROW;
    } else if (props.game.showCountdown) {
      gameTimeText = countdownText;
    } else if (showDaysCounter) {
      gameTimeText = termsUtils?.formatTerm(termsUtils.terms.WEB_GC_DAYS, {NUM: daysLeft})
    } else if (showDate) {
      gameTimeText = date;
    }

    return gameTimeText;
  }

  const newProps = {
    gameTimeText: gameTimeText(),
    ...props
  }

  return <Countdown {...newProps}/>;
});
